import AsyncSelect from 'react-select/async';
import { getRandomUid } from 'utilities/uuid.service';
import { useEffect, useState } from 'react';
import useCourses from 'hooks/API/GET/useCourses';

function CoursesMultiSelect({
  enableAPI,
  isMulti,
  values,
  handleChange,
  options = [],
  dependencies = {},
}) {
  const { query = {} } = dependencies;
  const [courses, setCourses] = useState([]);
  const [defaultCourses, setDefaultCourses] = useState([]);

  // Only call API if enableAPI is true
  const { data, isLoading } = useCourses({
    enabled: enableAPI && (!options || options.length === 0), // Only fetch if no static options
    configs: { params: { mode: 'dropdown', ...query } },
  });

  const _id = getRandomUid();

  useEffect(() => {
    // If options are provided (static), use them; otherwise fetch from API
    if (options && Array.isArray(options) && options.length > 0) {
      setCourses(options);
    } else if (data?.data && Array.isArray(data.data) && data.data.length > 0) {
      setCourses(data.data.map((item) => ({ label: item.courseName, value: item._id })));
    } else {
      setCourses([]);
    }
  }, [data?.data, options]);

  useEffect(() => {
    setDefaultCourses(values ?? []);
  }, [values]);

  return (
    <>
      <label htmlFor={_id}>Courses *</label>
      <AsyncSelect
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: '#e9baf0',
            'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
          }),
          multiValue: (styles) => {
            return {
              ...styles,
              backgroundColor: '#fadbff',
            };
          },
        }}
        inputId={_id}
        isMulti={isMulti}
        cacheOptions
        isLoading={isLoading || (enableAPI && courses.length === 0 && !options?.length)}
        onChange={handleChange}
        defaultOptions={courses}
        options={courses}
        value={defaultCourses}
        isDisabled={courses.length === 0}
      />
    </>
  );
}

CoursesMultiSelect.defaultProps = {
  values: [],
  isMulti: true,
  options: [],
  handleChange: () => {},
};

export default CoursesMultiSelect;
